class AudioPlayerService {
  constructor() {
    this.isSpeaking = false;
    this.onPlayStateChange = null;
    this.utterance = null;
    this.lastText = "";
    this.rate = 0.9;
    this.pitch = 1.1;
    this.enabled = true;
  }

  setConfig(config) {
    if (config.rate !== undefined) this.rate = config.rate;
    if (config.pitch !== undefined) this.pitch = config.pitch;
    if (config.enabled !== undefined) this.enabled = config.enabled;
  }

  playText(text) {
    if (!text || this.isSpeaking || !this.enabled) return;
    if (text === this.lastText) return;
    this.stop();
    this.lastText = text;

    // Use browser TTS directly - works on any network including proxy/VPN
    this.playBrowserTTS(text);
  }

  playBrowserTTS(text) {
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.rate = this.rate;
    utterance.pitch = this.pitch;
    utterance.volume = 1.0;

    const voices = speechSynthesis.getVoices();
    const femaleVoice = voices.find(function(v) {
      return v.lang.startsWith("en") &&
        (v.name.includes("Female") || v.name.includes("Samantha") || v.name.includes("Google"));
    });
    if (femaleVoice) utterance.voice = femaleVoice;

    utterance.onstart = function() { this.isSpeaking = true; this.notify(); }.bind(this);
    utterance.onend = function() { this.isSpeaking = false; this.lastText = ""; this.notify(); }.bind(this);
    utterance.onerror = function() { this.isSpeaking = false; this.lastText = ""; this.notify(); }.bind(this);

    speechSynthesis.speak(utterance);
  }

  stop() {
    if (this.isSpeaking) speechSynthesis.cancel();
    this.isSpeaking = false;
    this.lastText = "";
    this.notify();
  }

  setOnPlayStateChange(cb) { this.onPlayStateChange = cb; }

  notify() {
    if (this.onPlayStateChange) {
      this.onPlayStateChange({ isSpeaking: this.isSpeaking });
    }
  }
}

export default new AudioPlayerService();
